import React, { useEffect, useState } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Button,
  Row,
  Col,
  Input
} from 'reactstrap';
import * as commonActions from '@common/common.action';
import { useDispatch } from 'react-redux';
import IntlMessage from "../../../../helpers/intlMessage";

export default function ModalPeso(props) {
  const [modalAberto, setModalAberto] = useState(false);
  const [pesoG, setPesoG] = useState();
  const [pesoKG, setPesoKG] = useState();
  const backdrop = !props.backdrop ? false : props.backdrop;
  const keyboard = props.keyboard === undefined ? true : props.keyboard;
  const dispatch = useDispatch();
  useEffect(() => {
    setModalAberto(props.showModalPeso);
    dispatch(commonActions.showModal(props.showModalPeso));
    resetModal();
  }, [props.showModalPeso]);

  function resetModal() {
    setPesoG(0);
    setPesoKG(0);
  }

  useEffect(() => {
    changePesoG(props.peso);
  }, [props.peso]);

  function changePesoG(el) {
    if (!el) {
      setPesoKG(el);
      setPesoG(el);
      return;
    }
    setPesoG(el);
    setPesoKG(Number(el) / 1000);
  }
  function changePesoKG(el) {
    if (!el) {
      setPesoKG(el);
      setPesoG(el);
      return;
    }
    setPesoKG(el);
    if (Number(el) === 0) {
      setPesoG(0);
    } else {
      setPesoG(Number(el) * 1000);
    }
  }
  function toggle() {
    setModalAberto(!modalAberto);
    dispatch(commonActions.showModal(!modalAberto));
    props.onModal(!modalAberto);
  }

  return (
    <React.Fragment>

      <div>

        <Modal
          className='modal-confirm'
          backdrop={backdrop}
          keyboard={keyboard}
          centered
          isOpen={modalAberto}
          toggle={toggle}
        >
          <ModalHeader
            toggle={
              !props.close
                ? toggle
                : props.close
            }
          >
            Informe o peso
          </ModalHeader>
          <ModalBody>
            <Row>
              <Col>
                <FormGroup className={`confirmar-primary`}>
                  <Label>Peso em (g):</Label>
                  <Input type="number" value={pesoG} onChange={(e) => changePesoG(e.target.value)} />
                </FormGroup>
              </Col>
              <Col>
                <FormGroup className={`confirmar-primary`}>
                  <Label>Peso em (Kg):</Label>
                  <Input type="number" value={pesoKG} onChange={(e) => changePesoKG(e.target.value)} />
                </FormGroup>
              </Col>
            </Row>

          </ModalBody>
          <ModalFooter>
            <Button
              onClick={
                !props.cancelar
                  ? toggle
                  : props.cancelar
              }
              className={`button-cancel`}
              color='secondary'
            >
              <IntlMessage id="dashboards.examDetails.cancel" />
            </Button>
            <Button
              className={`button-confirm`}
              onClick={() => props.onPeso(pesoG)}
              disabled={(!pesoG && pesoG !== 0) || (!pesoKG && pesoKG !== 0)}
              color='primary'
            >
              Confirmar
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    </React.Fragment>);
}


// WEBPACK FOOTER //
// ./src/pages/descarte/modais/peso/index.js